import type { Vault } from '@/types/vault'
import type { IconSize } from '../icons/common'
import { ErrorIcon } from '../icons/error'
import { InfoIcon } from '../icons/info'

type Severity = Vault['flags'][number]['severity']

interface Props {
  severity: Severity
  size?: IconSize
  className?: string
}

export const SeverityIcon = ({ severity, size = 16, className }: Props) => {
  switch (severity) {
    case 'critical':
    case 'warning':
      return <ErrorIcon size={size} className={className} />
    case 'info':
      return <InfoIcon size={size} className={className} />
  }
}
